import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '../../../App/Components'
import { IProductBrand } from '../../../Product/DataStore/IProductBrand'
import { DashboardCardTopRightContainer } from '../styles'

import { Client } from './Client/Client'
import { IBestSold } from './Client/IBestSold'
import { SecondClient } from './Client/ProductBrands/Client'
import { IProps } from './IProps'
import { ISoldStat } from './ISoldStat'
import {
  CategoryName,
  ProductBrand,
  ProductImage,
  ProductName,
  ProductWrapper,
  RightTopLeftCard,
  SalesText,
} from './style'
import { findProductBrandAndCategory } from './utils/findProductBrandAndCategory/findProductBrandAndCategory'

export const BestSoldCards: FunctionComponent<IProps> = ({
  from,
  to,
  windowWidth,
}) => {
  const { t } = useTranslation()

  const [totalSales, setTotalSales] = useState<IBestSold[]>([])
  const [productBrands, setProductBrands] = useState<IProductBrand[]>([])
  const [soldStatsData, setSoldStatsData] = useState<ISoldStat[]>([])

  useEffect(() => {
    Client.getTopSoldProducts(from, to).then(sales => {
      return setTotalSales(sales)
    })

    SecondClient.getProductBrands().then(productBrandArray =>
      setProductBrands(productBrandArray),
    )
  }, [from, to])

  useEffect(() => {
    if (totalSales.length > 0 && productBrands.length > 0) {
      const soldStats = totalSales.map((sale: IBestSold): ISoldStat => {
        const foundBrandAndCategory = findProductBrandAndCategory(
          productBrands,
          sale.product.categoryId,
        )
        return {
          brandName: foundBrandAndCategory ? foundBrandAndCategory[0].name : '',
          categoryName: foundBrandAndCategory
            ? foundBrandAndCategory[1].name
            : '',
          name: sale.product.name,
        }
      })

      setSoldStatsData(soldStats)
    }
  }, [totalSales, productBrands])

  const combinedDataArray = totalSales.map((item, i) => ({
    ...item,
    ...soldStatsData[i],
  }))

  if (!totalSales || !productBrands || !combinedDataArray) {
    return <Spinner />
  }

  return (
    <>
      <DashboardCardTopRightContainer windowWidth={windowWidth}>
        {combinedDataArray.map(data => (
          <RightTopLeftCard
            key={`topsale${data.product.id}`}
            windowWidth={windowWidth}>
            <ProductImage
              src={
                data.product.imageId
                  ? `https://files.optios.net?id=${data.product.imageId}&w=200&h=200&fit=crop`
                  : `/img/product.svg`
              }
              alt="product-image"
            />
            <ProductWrapper>
              <SalesText>
                {data.amountSold} {t('sales')}
              </SalesText>

              <ProductBrand>{data.brandName}</ProductBrand>
              <ProductName>{data.product.name}</ProductName>
              <CategoryName>{data.categoryName}</CategoryName>
            </ProductWrapper>
          </RightTopLeftCard>
        ))}
        {totalSales.length < 3 && (
          <RightTopLeftCard windowWidth={windowWidth}>
            <ProductImage src={'/img/product.svg'} alt="product" />
            <ProductWrapper>
              <SalesText>{t('There is no sales data')}</SalesText>
              <ProductBrand> - </ProductBrand>
              <ProductName> - </ProductName>
            </ProductWrapper>
          </RightTopLeftCard>
        )}
      </DashboardCardTopRightContainer>
    </>
  )
}
